import { RoomState } from './types';
import type { RoomStateConfig, AudioConfig } from './types';

export const ROOM_STATE_CONFIGS: Record<RoomState, RoomStateConfig> = {
  [RoomState.Standby]: { name: '待命', description: '等待唤醒指令', state: RoomState.Standby },
  [RoomState.Awakened]: { name: '唤醒', description: '已唤醒，等待输入', state: RoomState.Awakened },
  [RoomState.Listening]: { name: '聆听', description: '正在聆听用户输入', state: RoomState.Listening },
  [RoomState.Responding]: { name: '回应', description: 'AI 正在回复', state: RoomState.Responding },
};

export const DEFAULT_AUDIO_CONFIG: Required<AudioConfig> = {
  sampleRate: 16000,
  channelCount: 1,
  sampleSize: 16,
  echoCancellation: true,
  noiseSuppression: true,
  autoGainControl: true,
} as const;

export const READY_TIMEOUT = 120_000;
export const READY_DELAY = 1000;
export const DEFAULT_FPS = 25;

/** 超长超时值，意图是让客户端控制驱动休眠而非驱动端自行超时 */
export const DRIVER_SLEEP_DISABLED_TIMEOUT = 25 * 10_000_000;

// ==================== 重连默认配置 ====================

export const DEFAULT_RECONNECT_MAX_ATTEMPTS = 3;
export const DEFAULT_RECONNECT_BASE_DELAY_MS = 2000;
export const DEFAULT_RECONNECT_MAX_DELAY_MS = 30_000;
export const DEFAULT_RECONNECT_ATTEMPT_TIMEOUT_MS = 30_000;
export const MESSAGE_SEND_MAX_RETRIES = 2;
export const MESSAGE_SEND_RETRY_DELAY_MS = 500;
